import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExportAsService, ExportAsConfig, SupportedExtensions  } from 'ngx-export-as';
import { Router, ActivatedRoute } from '@angular/router'

import { environment } from 'src/app//lib/environment';
import { Urls } from 'src/app//lib/urls';
import { GeneralService } from 'src/app/services/general.service';
import { EventService } from 'src/app/services/event/event.service';
import { NullTemplateVisitor } from '@angular/compiler';
import { MessageService } from './../../../../services/defaults/message.service';

import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { DatePipe } from '@angular/common';
import { count } from 'rxjs/operators';
import { HttpClient , HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-delegate-itinerary-report',
  templateUrl: './delegate-itinerary-report.component.html',
  styleUrls: ['./delegate-itinerary-report.component.scss'],
  providers: [DatePipe]
})
export class DelegateItineraryReportComponent implements OnInit {

  protected autoTable_dim = 0;
  filebase64data: any;

  exportAsConfig: ExportAsConfig = {
    type: 'pdf',
    elementIdOrContent: 'statistic_reports',
    options: {
      jsPDF: {
        orientation: 'portrait'
      },
      margin: 1,
      // margins: {
      //   top: '20'
      // }
      compress: true,
      pagebreak: true,
      showall: true,
    }
  };

  counter = 1;
  meetingList = 'meetingList';
  event_delegate_id: any = null;
  delegate_id: any = null;
  delegate_email: any = null;
  delegate_name: any = null;
  event_id: any = null;
  event: any = null;
  meeting_itinerary: any = null;
  type: string = 'Downloading';
  zoom_setting: any = null;

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private exportAsService: ExportAsService,
    private activatedRoute: ActivatedRoute,
		private env : environment,
		private gen : GeneralService,
		protected messageService: MessageService,
    public eventService: EventService,
    private datePipe: DatePipe,
    protected http:HttpClient,
  ) {
   }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe( url_param =>{
      this.event_id = + url_param.get('event_id');
    });

    this.activatedRoute.queryParams.subscribe(params => {
      if(params['event_delegate_id']){
        this.event_delegate_id = params.event_delegate_id;
        // console.log('event_delegate_id', this.event_delegate_id);
      }
      if(params['delegate_name']){
        this.delegate_name = params.delegate_name;
        // console.log('delegate_name', this.delegate_name);
      }
      if(params['delegate_id']){
        this.delegate_id = params.delegate_id;
        // console.log('delegate_id', this.delegate_id);
      }
      if(params['delegate_email']){
        this.delegate_email = params.delegate_email;
        // console.log('delegate_email', this.delegate_email);
      }
      if(params['type']){
        this.type = params.type;
        // console.log('type', this.type);
      }
    });

    this.getItinerarySchedule();
    this.getItineraryScheduleReport();
  }

  ngAfterViewInit() {
    this.getZoomSetting();

    setTimeout(()=>{
      this.meeting_itinerary.forEach(res => {
        let temp_data = [];
        if(res.data){
          res['meeting_date'] = this.datePipe.transform(res.date, 'MMM d, y');
          res.data.forEach((res1, key) => {
            let temp_arr = [];
            res1['meeting_time'] = this.datePipe.transform(res1.start_time_delegate, 'h:mm a') +' - '+this.datePipe.transform(res1.end_time_delegate, 'h:mm a');
            res1['other_delegate_fullname'] = this.event_delegate_id == res1.d1_id ? res1.d2_fullname : res1.d1_fullname;
            res1['other_delegate_company'] = this.event_delegate_id == res1.d1_id ? res1.d2_company_name : res1.d1_company_name;
            res1['other_delegate_jobtitle'] = this.event_delegate_id == res1.d1_id ? res1.d2_job_title : res1.d1_job_title;
            if(this.eventService.eventFullDetails.type == 1){
              if(res1.table_type == 3){
                res1['table'] = 'Table '+res1.table_table_no;
              }else if(res1.table_type == 2){
                res1['table'] = 'Booth '+res1.table_table_no;
              }else if(res1.table_type == 1){
                res1['table'] = 'VIP '+res1.table_table_no;
              }
            }else{
              res1['zoom_email_address'] = this.event_delegate_id != res1.d1_id ? res1.d2_social_media_links.zoom : res1.d1_social_media_links.zoom;
              if(this.zoom_setting.status == '1'){
                let url = this.env.getUrl(Urls.api_virtualconference_shortenurl);

                console.log('zoom condition', this.delegate_email +' == '+ res1.d1_email)

                if(this.delegate_email == res1.d1_email){
                  // res1['meeting_link'] = res1.zoom_meeting_link_1;
                  let type = "s"; //start
                  url += '?t=' + type;
                  url += '&c=' + res1.zoom_id;
                  res1['meeting_link'] = url;
                }else{
                  //res1['meeting_link'] = res1.zoom_meeting_link_2;
                  let type = "j";
                  url += '?t=' + type;
                  url += '&c=' + res1.zoom_id;
                  res1['meeting_link'] = url;
                }
              }
            }

            temp_arr.push(this.datePipe.transform(res1.start_time_delegate, 'h:mm a') +' - '+this.datePipe.transform(res1.end_time_delegate, 'h:mm a'));
            temp_arr.push(this.event_delegate_id == res1.d1_id ? res1.d2_fullname : res1.d1_fullname);
            temp_arr.push(this.event_delegate_id == res1.d1_id ? res1.d2_company_name : res1.d1_company_name);
            temp_arr.push(this.event_delegate_id == res1.d1_id ? res1.d2_job_title : res1.d1_job_title);
            if(this.eventService.eventFullDetails.type == 1){
              if(res1.table_type == 3){
                temp_arr.push('Table '+res1.table_table_no);
              }else if(res1.table_type == 2){
                temp_arr.push('Booth '+res1.table_table_no);
              }else if(res1.table_type == 1){
                temp_arr.push('VIP '+res1.table_table_no);
              }
            }else{
              temp_arr.push(this.event_delegate_id == res1.d1_id ? res1.d2_social_media_links.zoom : res1.d1_social_media_links.zoom);
              if(this.zoom_setting.status == '1'){
                let url = this.env.getUrl(Urls.api_virtualconference_shortenurl);

                console.log('zoom condition', this.delegate_email +' == '+ res1.d1_email)

                if(this.delegate_email == res1.d1_email){
                  // res1['meeting_link'] = res1.zoom_meeting_link_1;
                  let type = "s"; //start
                  url += '?t=' + type;
                  url += '&c=' + res1.zoom_id;
                  temp_arr.push(url);
                }else{
                  //res1['meeting_link'] = res1.zoom_meeting_link_2;
                  let type = "j";
                  url += '?t=' + type;
                  url += '&c=' + res1.zoom_id;
                  temp_arr.push(url);
                }
              }
            }

            temp_data.push(temp_arr);
          });
          res['meeting_data'] = temp_data;
        }
      });
      console.log('this.meeting_itinerary', this.meeting_itinerary);
      if(this.meeting_itinerary){
        if(this.type == "Downloading"){
          this.exportPdf(this.meeting_itinerary);

        }else if(this.type == "Sending"){
          this.sendPdf(this.meeting_itinerary);
        }
      }
    }, 5000)

    setTimeout(()=>{
      if(this.eventService.eventFullDetails.type == 1){
        this.router.navigate(['/admin/event/delegates/'+this.event_id+'/profile/'+this.delegate_id]);
      }else{
        this.router.navigate(['/admin/event/delegates-virtual/'+this.event_id+'/profile/'+this.delegate_id]);
      }
    }, 5000)

  }

  getItinerarySchedule(){
    let url = this.env.getUrl(Urls.api_delegate_meetingitinerary);
    let formData = {
      event_id: this.event_id,
      event_delegate_id: this.event_delegate_id
    };


    if(this.eventService.eventFullDetails.type == 2){
      formData['is_virtual'] = true;
    }

    console.log('get itinerary form data', formData);

    this.gen.post(url, formData).subscribe(data=>{
      if(data.error == 0){
        // console.log('schedule_itineray', data);
        this.event = data.event;
        this.meeting_itinerary = data.data;
      }
    });
  }

  getItineraryScheduleReport(){
    this.spinner.show(this.meetingList);

    setTimeout(()=>{
      this.spinner.hide(this.meetingList);
    }, 5000)
  }

  /* print filtered meeting scheduled list */
  exportPdf(data){
    if(data){
      let a = this;

      let doc;
      if(a.eventService.eventFullDetails.type == 1){
        doc = new jsPDF();
      }else{
        doc = new jsPDF({
          orientation: "landscape"
        });
      }

      doc.setTextColor(40);
      doc.setFontStyle('normal');
      doc.setFontSize(13);

      let file_name = a.eventService.eventFullDetails.name + " : " + a.delegate_name + "'s meeting schedules ";

      let letter_head = "/assets/images/f2f_logo.png";
      let dataUrl = "data:image/png;base64,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";
      a.toDataURL(letter_head, function(dataUrl){
        console.log('dataUrl', dataUrl);
        let headerTitle = file_name;

        let headerY = 20;
        if(letter_head){
          // addImage(imageData, format, x, y, width, height, alias, compression, rotation)
          doc.addImage(dataUrl, 'PNG', 15, 15, 45, 10, '', 'FAST');
          headerY = headerY + 15;
        }
        // text(text, x, y, optionsopt, transform)
        doc.text(headerTitle, 15, headerY, {maxWidth: 180});

        let headerTitle_dim = doc.getTextDimensions(headerTitle);
        let splitTitle = doc.splitTextToSize(headerTitle, 180, {fontSize:13});
        let headerTitle_height = (headerTitle_dim.h * splitTitle.length) + 2;
        doc.setFontSize(11);

        // doc.text(a.eventService.eventFullDetails.event_date, 15, headerTitle_height + headerY, {maxWidth: 180});
        // console.log('ck event dates', a.eventService.eventFullDetails.event_date)
        if(a.eventService.eventFullDetails.type == 1){
          doc.text(a.eventService.eventFullDetails.event_date, 15, headerTitle_height + headerY, {maxWidth: 180});
        }else{
          let v_date = localStorage.getItem('itinerary_v_date')
          doc.text(v_date, 15, headerTitle_height + headerY, {maxWidth: 180});
        }


        let eventDate_dim = doc.getTextDimensions(a.eventService.eventFullDetails.event_date);
        let spliteventDate = doc.splitTextToSize(a.eventService.eventFullDetails.event_address,180,{fontSize:10});
        a.autoTable_dim = (eventDate_dim.h * spliteventDate.length) + headerTitle_height + headerY + 1;

        data.forEach(element => {
          if(element.data){
            let rows = element.data;
            if(element.data){
              if(a.eventService.eventFullDetails.type == 1){
                doc.autoTable({
                  theme: 'striped',
                  columnStyles: {
                    europe: { halign: 'center' },
                    0: {
                      cellWidth: 30,
                      fontSize: 8
                    },
                    1: {
                      cellWidth: 35,
                      fontSize: 8
                    },
                    2: {
                      cellWidth: 50,
                      fontSize: 8
                    },
                    3: {
                      cellWidth: 48,
                      fontSize: 8
                    },
                    4: {
                      cellWidth: 18,
                      fontSize: 8
                    },
                  },
                  head: [
                    [{ content: element.meeting_date, colSpan: 6, styles: { halign: 'center', fillColor: [104, 139, 6], textColor: [256, 256, 256] } }],
                    [
                      { content: 'Meeting time'},
                      { content: 'Delegate Name'},
                      { content: 'Company'},
                      { content: 'Position'},
                      { content: 'Table No'},
                    ]
                  ],
                  body: element.meeting_data,
                  margin: { top: a.autoTable_dim },
                  styles: { fillColor: [204, 204, 204], textColor: [68, 68, 68] }
                });
              }else{
                if(a.zoom_setting.status == '1'){
                  doc.autoTable({
                    theme: 'striped',
                    columnStyles: {
                      europe: { halign: 'center' },
                      0: {
                        cellWidth: 30,
                        fontSize: 8
                      },
                      1: {
                        cellWidth: 35,
                        fontSize: 8
                      },
                      2: {
                        cellWidth: 50,
                        fontSize: 8
                      },
                      3: {
                        cellWidth: 40,
                        fontSize: 8
                      },
                      4: {
                        cellWidth: 50,
                        fontSize: 8
                      },
                      5: {
                        fontSize: 8
                      }
                    },
                    head: [
                      [{ content: element.meeting_date, colSpan: 6, styles: { halign: 'center', fillColor: [104, 139, 6], textColor: [256, 256, 256] } }],
                      [
                        { content: 'Meeting time'},
                        { content: 'Delegate Name'},
                        { content: 'Company'},
                        { content: 'Position'},
                        { content: 'Zoom Email Address Id'},
                        { content: 'Zoom Meeting URL', styles: { cellWidth: 'wrap'}},
                      ]
                    ],
                    body: element.meeting_data,
                    margin: { top: a.autoTable_dim },
                    styles: { fillColor: [204, 204, 204], textColor: [68, 68, 68] }
                  });
                }else{
                  doc.autoTable({
                    theme: 'striped',
                    columnStyles: {
                      europe: { halign: 'center' },
                      0: {
                        cellWidth: 30,
                        fontSize: 8
                      },
                      1: {
                        cellWidth: 45,
                        fontSize: 8
                      },
                      2: {
                        cellWidth: 65,
                        fontSize: 8
                      },
                      3: {
                        cellWidth: 70,
                        fontSize: 8
                      },
                      4: {
                        cellWidth: 45,
                        fontSize: 8
                      },
                    },
                    head: [
                      [{ content: element.meeting_date, colSpan: 6, styles: { halign: 'center', fillColor: [104, 139, 6], textColor: [256, 256, 256] } }],
                      [
                        { content: 'Meeting time'},
                        { content: 'Delegate Name'},
                        { content: 'Company'},
                        { content: 'Position'},
                        { content: 'Zoom Email Address Id'}
                      ]
                    ],
                    body: element.meeting_data,
                    margin: { top: a.autoTable_dim },
                    styles: { fillColor: [204, 204, 204], textColor: [68, 68, 68] }
                });
                }
              }
            }
          }
        });

        /* Using HTML Code  */
        // doc.autoTable({
        //   html: document.getElementById("my-table"),
        //   theme: 'striped',
        //   margin: { top: a.autoTable_dim },
        //   columnStyles: {
        //     0: {
        //       cellWidth: 'wrap',
        //     },
        //     1: {
        //       cellWidth: 'wrap',
        //     }
        //   },
        //   useCss: true
        // });

        doc.save(a.eventService.eventFullDetails.name + ' Final Itinerary'+'.pdf');
      });
    }
  }

  toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
      var reader = new FileReader();
      reader.onloadend = function() {
        callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }

  sendPdf(data){
    let a = this;

    let doc;
    if(a.eventService.eventFullDetails.type == 1){
      doc = new jsPDF();
    }else{
      doc = new jsPDF({
        orientation: "landscape"
      });
    }

    doc.setTextColor(40);
    doc.setFontStyle('normal');
    doc.setFontSize(13);

    let file_name = a.eventService.eventFullDetails.name + " : " + a.delegate_name + "'s meeting schedules ";

    let letter_head = "/assets/images/f2f_logo.png";
    this.toDataURL(letter_head, function(dataUrl){
      console.log('dataUrl', dataUrl);
      let headerTitle = file_name;

      let headerY = 20;
      if(letter_head){
        // addImage(imageData, format, x, y, width, height, alias, compression, rotation)
        doc.addImage(dataUrl, 'PNG', 15, 15, 45, 10, '', 'FAST');
        headerY = headerY + 15;
      }
      // text(text, x, y, optionsopt, transform)
      doc.text(headerTitle, 15, headerY, {maxWidth: 180});

      let headerTitle_dim = doc.getTextDimensions(headerTitle);
      let splitTitle = doc.splitTextToSize(headerTitle, 180, {fontSize:13});
      let headerTitle_height = (headerTitle_dim.h * splitTitle.length) + 2;
      console.log('headerTitle_dim', headerTitle_dim);
      console.log('splitTitle', splitTitle);
      console.log('headerTitle_height', headerTitle_height);
      doc.setFontSize(11);

      if(a.eventService.eventFullDetails.type == 1){
        doc.text(a.eventService.eventFullDetails.event_date, 15, headerTitle_height + headerY, {maxWidth: 180});
      }else{
        let v_date = localStorage.getItem('itinerary_v_date')
        doc.text(v_date, 15, headerTitle_height + headerY, {maxWidth: 180});
      }


      // console.log('ck event date', a.eventService.eventFullDetails.event_date)
      let eventDate_dim = doc.getTextDimensions(a.eventService.eventFullDetails.event_date);
      let spliteventDate = doc.splitTextToSize(a.eventService.eventFullDetails.event_address,180,{fontSize:10});
      a.autoTable_dim = (eventDate_dim.h * spliteventDate.length) + headerTitle_height + headerY + 1;

      data.forEach(element => {
        if(element.data){
          let rows = element.data;
          if(element.data){
            if(a.eventService.eventFullDetails.type == 1){
              doc.autoTable({
                theme: 'striped',
                columnStyles: {
                  europe: { halign: 'center' },
                  0: {
                    cellWidth: 30,
                    fontSize: 8
                  },
                  1: {
                    cellWidth: 35,
                    fontSize: 8
                  },
                  2: {
                    cellWidth: 50,
                    fontSize: 8
                  },
                  3: {
                    cellWidth: 48,
                    fontSize: 8
                  },
                  4: {
                    cellWidth: 18,
                    fontSize: 8
                  },
                },
                head: [
                  [{ content: element.meeting_date, colSpan: 6, styles: { halign: 'center', fillColor: [104, 139, 6], textColor: [256, 256, 256] } }],
                  [
                    { content: 'Meeting time'},
                    { content: 'Delegate Name'},
                    { content: 'Company'},
                    { content: 'Position'},
                    { content: 'Table No'},
                  ]
                ],
                body: element.meeting_data,
                margin: { top: a.autoTable_dim },
                styles: { fillColor: [204, 204, 204], textColor: [68, 68, 68] }
              });
            }else{
              if(a.zoom_setting.status == '1'){
                doc.autoTable({
                  theme: 'striped',
                  columnStyles: {
                    europe: { halign: 'center' },
                    0: {
                      cellWidth: 30,
                      fontSize: 8
                    },
                    1: {
                      cellWidth: 35,
                      fontSize: 8
                    },
                    2: {
                      cellWidth: 50,
                      fontSize: 8
                    },
                    3: {
                      cellWidth: 40,
                      fontSize: 8
                    },
                    4: {
                      cellWidth: 50,
                      fontSize: 8
                    },
                    5: {
                      fontSize: 8
                    }
                  },
                  head: [
                    [{ content: element.meeting_date, colSpan: 6, styles: { halign: 'center', fillColor: [104, 139, 6], textColor: [256, 256, 256] } }],
                    [
                      { content: 'Meeting time'},
                      { content: 'Delegate Name'},
                      { content: 'Company'},
                      { content: 'Position'},
                      { content: 'Zoom Email Address Id'},
                      { content: 'Zoom Meeting URL', styles: { cellWidth: 'wrap'}},
                    ]
                  ],
                  body: element.meeting_data,
                  margin: { top: a.autoTable_dim },
                  styles: { fillColor: [204, 204, 204], textColor: [68, 68, 68] }
                });
              }else{
                doc.autoTable({
                  theme: 'striped',
                  columnStyles: {
                    europe: { halign: 'center' },
                    0: {
                      cellWidth: 30,
                      fontSize: 8
                    },
                    1: {
                      cellWidth: 45,
                      fontSize: 8
                    },
                    2: {
                      cellWidth: 65,
                      fontSize: 8
                    },
                    3: {
                      cellWidth: 70,
                      fontSize: 8
                    },
                    4: {
                      cellWidth: 45,
                      fontSize: 8
                    },
                  },
                  head: [
                    [{ content: element.meeting_date, colSpan: 6, styles: { halign: 'center', fillColor: [104, 139, 6], textColor: [256, 256, 256] } }],
                    [
                      { content: 'Meeting time'},
                      { content: 'Delegate Name'},
                      { content: 'Company'},
                      { content: 'Position'},
                      { content: 'Zoom Email Address Id'}
                    ]
                  ],
                  body: element.meeting_data,
                  margin: { top: a.autoTable_dim },
                  styles: { fillColor: [204, 204, 204], textColor: [68, 68, 68] }
                });
              }
            }
          }
        }
      });
      var fileBlob = doc.output('blob');
      var reader = new FileReader();

      reader.readAsDataURL(fileBlob);
      reader.onloadend = function() { // for blob to base64
        a.filebase64data = reader.result;
        if(a.filebase64data){
          let url = a.env.getUrl(Urls.api_delegates_senditineraries);
          let formData = new FormData();
          formData.append('file_name', file_name);
          formData.append('file', fileBlob);
          formData.append('b64_file', a.filebase64data);
          formData.append('event_name', a.eventService.eventFullDetails.name);
          formData.append('delegate_email', a.delegate_email);

          a.spinner.show(a.meetingList);

          a.gen.post(url, formData).subscribe(send=>{
            console.log('data_send_pdf', send);
            if(send.error == 0){

            }
          });
        }
      }
      //doc.save(a.eventService.eventFullDetails.name + ' Final Itinerary'+'.pdf');
    });
  }

  getZoomSetting(){
    let url = this.env.getUrl(Urls.api_virtualconference_getzoomsettings);

    this.gen.get(url).subscribe(data=>{
      if(data.error == 0){
        this.zoom_setting = data.data;
      }
    });
  }

}
